import type { PostPublicLogin } from "@services/apiEcms/apiEcms.types";

export const ACCOUNTS = {
  DAE_TEST1: {
    accessToken: "DAE_TEST1",
    email: "test-dae1@kuriosity.fr",
    expiresIn: 86400,
    group: "DAE - INTERIEUR",
    refreshToken: "DAE_TEST1",
    tokenType: "Bearer",
  },
  DAE_AUTH: {
    accessToken: "DAE_AUTH",
    email: "test-auth@kuriosity.fr",
    expiresIn: 86400,
    group: "LAVERIE DES QUATRE CHEMINS",
    refreshToken: "DAE_AUTH",
    tokenType: "Bearer",
  },
  MINT_ADMIN: {
    accessToken: "MINT_ADMIN",
    email: "admin@anonyme.com",
    expiresIn: 86400,
    group: "GROUPE ANONYMISE",
    refreshToken: "MINT_ADMIN",
    tokenType: "Bearer",
  },
  MINT_ADMIN2: {
    accessToken: "MINT_ADMIN2",
    email: "admin2@anonyme.com",
    expiresIn: 86400,
    group: "GROUPE ANONYMISE",
    refreshToken: "MINT_ADMIN2",
    tokenType: "Bearer",
  },
  MINT_USER: {
    accessToken: "MINT_USER",
    email: "user@anonyme.com",
    expiresIn: 86400,
    group: "GROUPE ANONYMISE",
    refreshToken: "MINT_USER",
    tokenType: "Bearer",
  },
} satisfies Record<string, PostPublicLogin>;
